import { useTranslation } from 'react-i18next';
import UserService from '../../../services/UserService';
import { getStatusTranslationKey, getStatusExplanationTranslationKey, isMessageTooOld, GetMessageStatusColor } from '../DashboardUtilities';
import RenderOnRole from "../../../Utilities/RenderOnRole";
import CopyBtn from './CopyBtn';

const MessageRow = ({ message, index, isSelected, onToggle, berichtDisplayFieldDict }) => {
  const { t } = useTranslation();
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleString('nl-NL');
  };

  const isTooOld = isMessageTooOld(message.verzonden_datumtijd, message.interface_id);
  const canViewErrorMessage = UserService.hasRole(['Administrator', 'SD_Medewerker']);
  const showErrorMessage = canViewErrorMessage && ['3', '5', '6', '7'].includes(String(message.status));

  const handleRowClick = (e) => {
    const isShift = e.shiftKey;
    onToggle(message.id, index, isShift);
  };

  return (
    <tr
      className={`message-row ${isSelected ? 'selected' : ''} ${isTooOld ? 'message-too-old' : ''}`}
      onClick={handleRowClick}
      style={isTooOld ? { opacity: 0.5 } : {}}
      title={isTooOld ? 'Dit bericht is ouder dan 2 maanden en kan niet worden gedownload' : ''}
    >
      <td className="px-4 py-3">
        <input
          type="checkbox"
          checked={isSelected}
          readOnly
          className="w-4 h-4 cursor-pointer"
        />
      </td>
      {berichtDisplayFieldDict.map((berichtDisplayInfo) => {
        var value = berichtDisplayInfo.id === "verzonden_datumtijd" || berichtDisplayInfo.id === "ontvangen_datumtijd" ? formatDate(message[berichtDisplayInfo.id]) : message[berichtDisplayInfo.id];
        if(!berichtDisplayInfo.active) return null;
        else if(berichtDisplayInfo.id === "status") return (
          <td className="px-4 py-3" key={message.id + berichtDisplayInfo.id}>
          <span className={`status-badge ${GetMessageStatusColor(message.status)}`}
          title={[
            t(`messageStatusExplanations.${getStatusExplanationTranslationKey(message.status, UserService.hasRole(['Klant']))}`),
            showErrorMessage && message.errorMessage
          ].filter(Boolean).join(' ')}>
            {(() => {
              let key = getStatusTranslationKey(message.status, UserService.hasRole(['Klant']));
              return t(`messageStatuses.${key}`);
            })()}
          </span>
        </td>
        );
        else if(berichtDisplayInfo.employeeOnly) return (
          <RenderOnRole
            key={message.id + berichtDisplayInfo.id}
            roles={["Administrator", "SD_Medewerker"]}
          >
            <td className="px-4 py-3">
              {value}
              {berichtDisplayInfo.hasCopyBtn ? <CopyBtn text={value}/> : null}
            </td>
          </RenderOnRole>
        ); 
        else return (
          <td key={message.id + berichtDisplayInfo.id} className="px-4 py-3">
            {value + "" === "null" || value + "" === "undefined" ? "" : value}
            {berichtDisplayInfo.hasCopyBtn && value + "" !== "null" && value + "" !== "undefined" ? <CopyBtn text={value}/> : null}
          </td>
        );
      })}
    </tr>
  );
};

export default MessageRow;